import Timeline from '@/components/timeline/timeline.component'
import { useTranslation } from 'react-i18next'
import ActionsModal from './components/actions-modal/actions-modal.component'
import CardProfileComponent from './components/card-profile/card-profile.component'
import FooterModal from './components/footer-modal/footer-modal.component'
import TitleModal from './components/title-modal/title-modal.component'
import useNewTutorialInstagram, { Props } from './hooks/use-new-tutorial-instagram/use-new-tutorial-instagram.hook'

import './tutorial-instagram.component.scoped.scss'

export default (props: Props) => {
  const {
    width,
    height,
    activeStep,
    maxStep,
    notBusinessProfile,
    profile,
    action,
    handleCloseModal,
    getConfirmElement,
    getCancelElement,
    handlePreviousButtonClick,
  } = useNewTutorialInstagram(props)

  const { t } = useTranslation('modalVinculateSocialNetwork')

  return (
    <div
      className="tutorial-instagram display-flex justify-content-space-between"
      style={{ height: width < 991 ? `calc(${height}px - 15px - 15px)` : 'auto' }}
    >
      <div className="content-modal">
        <header>
          <ActionsModal onCloseModal={handleCloseModal} onPreviousButtonClick={handlePreviousButtonClick} />
          <TitleModal stepPage={activeStep?.page} maxStep={maxStep} />
          {notBusinessProfile && activeStep?.code === 'HOW_CHANGE_BUSINESS_ACCOUNT' && action == 'renew' ? (
            <h5 className="description m-0 mb-5">{t('modalTutorialInstagram.accountIsNotBusiness')}</h5>
          ) : activeStep?.description ? (
            <h5 className="description m-0 mb-5">{activeStep?.description}</h5>
          ) : null}
          {activeStep?.message ? <span className="message">{activeStep?.message}</span> : null}
          {notBusinessProfile && activeStep?.code === 'HOW_CHANGE_BUSINESS_ACCOUNT' && action === 'renew' ? (
            <CardProfileComponent profile={profile} />
          ) : null}
        </header>
        <div className="content-timeline scrollbar">
          <Timeline>
            {activeStep?.steps?.map((item, index) => (
              <Timeline.Item key={`${activeStep?.code}-${index}`}>{item}</Timeline.Item>
            ))}
          </Timeline>
        </div>
      </div>
      <FooterModal getConfirmElement={getConfirmElement} getCancelElement={getCancelElement} />
    </div>
  )
}
